import React from "react";
import { getFieldContainerClass, getFieldLabelClass } from "../../../util/util";

export default function FieldContainer({item, children, labelType, addContainerClass, translate}) {
    let itemLabel = generateLabel(item, translate);

    return (
        <React.Fragment key={item.name}>
            <div
                className={getFieldContainerClass(item?.metadata?.addContainerClass ?? addContainerClass , labelType ?? item.metadata?.labelType)}
            >
                {!!item?.metadata?.htmlBefore && item.metadata.htmlBefore(item)}

                <label
                    htmlFor={item?.props?.id ?? item.name}
                    className={getFieldLabelClass(item.metadata, labelType)}
                >
                    {!item?.metadata?.hideLabel && (
                        itemLabel
                    )}

                    {!!item?.metadata?.fieldOptions && (
                        <span className="ml-auto">
                            {item.metadata.fieldOptions(item)}
                        </span>
                    )}
                </label>

                {children}

                {!!item.errorMessage && (
                    <div className={"text-sm text-red-600 text-left"}>
                        {translate(item.errorMessage)}
                    </div>
                )}

                {!!item?.metadata?.note && !item.errorMessage && (
                    <p className="mt-1">
                        {item.metadata.note}
                    </p>
                )}

                {!!item?.metadata?.htmlAfter && item.metadata.htmlAfter(item)}
            </div>
        </React.Fragment>
    )
}

const generateLabel = (item, translate) => {
    const req = ((item.validate.includes("required") || item.validate.includes("empty")) && !item?.metadata?.hideReq);
    let itemLabel;

    if (!!item?.metadata?.labelRaw) {
        itemLabel = item.metadata.labelRaw + (req ? " *" : "");
    } else {
        itemLabel = (!!item?.metadata?.label) ? (translate("field." + item?.metadata?.label) + " " + (req ? "*" : "")) : (translate("field." + item.name) + " " + (req ? "*" : ""))
    }

    if (item?.metadata?.hideLabel) {
        itemLabel = "";
    }

    return itemLabel;
}